<template>
  <div>
    <Head :title="barazim.data.id.toString()"/>


    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/barazimet">Barazimet</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ barazim.data.id }}
    </h1>

    <trashed-message v-if="barazim.data.deleted_at" class="mb-6" @restore="restore"> Ky barazim është fshirë nga sistemi. </trashed-message>



    <div class=" bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 justify-between -mr-6 p-5">
        <div class="flex flex-wrap mb-4">
          <label class="font-bold">Statusi Aktual: &nbsp;</label>
          <p><span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="statusColor"
          >{{ barazim.data.status }}</span></p>
        </div>
      </div>
    </div>


    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">

        <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">

          <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 p-8">
<!--            <Link  v-if="!order.data.is_change"  class="mr-1" :href="`${order.data.id}/edit`" ><icon name="edit" class="mr-2 w-4 h-4"></icon></Link>-->
            <dropdown class="mr-2 w-4 h-4" placement="bottom-end">
              <template #default>
                <icon name="print" class="mr-2 w-4 h-4"></icon>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.barazim.order.pdf',{barazim: barazim.data.id})"  target="_blank">Printo PDF</a>
                </div>
              </template>
            </dropdown>
          </div>

          <a :href="route('seller.barazimet.excel.single',{barazim: barazim.data.id})" download class="mr-7 w-4 h-4"><icon name="excel"></icon></a>



        </div>
        <hr>


        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Barazimi (ID)</label>
            <p>{{barazim.data.id}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Biznesi</label>
            <p>{{ barazim.data.business}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pika marrëse</label>
            <p>{{barazim.data.location}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{ barazim.data.hr_created_at }}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Numri i dërgesave</label>
            <p>{{ barazim.data.orders_count }}</p>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/4">-->
<!--            <label class="font-bold">Numri i kthimit të mjeteve</label>-->
<!--            <p>{{ barazim.data.money_returns_count }}</p>-->
<!--          </div>-->

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Total shitje</label>
            <currency-number-format :number="`${barazim.data.total_sales}`"></currency-number-format>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/4">-->
<!--            <label class="font-bold">Total kthime të mjeteve - paguar nga posta</label>-->
<!--            <currency-number-format :number="`${barazim.data.money_return_cost}`"></currency-number-format>-->
<!--          </div>-->

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Total posta</label>
            <currency-number-format :number="`${barazim.data.total_shipping_cost}`"></currency-number-format>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Total shuma NETO për dorëzim</label>
            <currency-number-format :number="`${barazim.data.total_neto_amount}`"></currency-number-format>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Informata shtesë</label>
            <p>{{barazim.data.additional_info}}</p>
          </div>
        </div>
      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden p-5  w-full lg:w-1/2">
        <h1 class="mb-3 text-xl font-bold">Gjurmimi i barazimit</h1>

        <div class="flex flex-wrap -mb-8 p-8">
          <barazim-status-timeline :items="statusLogs.data"></barazim-status-timeline>
        </div>

      </div>
    </div>


    <div class="flex items-center mb-6">
      <h2 class=" text-2xl font-bold">Dërgesat</h2>
    </div>

    <search-input v-model="searchOrderForm.search" class="mr-4 mb-4 w-full max-w-md" @reset="reset"></search-input>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">

          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">ID e juaj</th>
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Pika marrëse</th>
          <th class="pb-4 pt-6 px-2">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-2">Produkti</th>
          <th class="pb-4 pt-6 px-2">Sasia</th>
          <th class="pb-4 pt-6 px-2">Madhësia e pakos</th>
          <th class="pb-4 pt-6 px-2">Çmimi</th>
          <th class="pb-4 pt-6 px-2">Posta</th>
          <th class="pb-4 pt-6 px-2">Qyteti</th>
          <th class="pb-4 pt-6 px-2">Statusi i edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t">
            <a class="flex items-center  px-2 py-4" :href="`/dergesat/${order.id}`" target="_blank" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              <icon v-if="order.barazim_id" name="paid" class="flex-shrink-0 ml-2 w-5 h-5 fill-gray-400" />
            </a>
          </td>

          <td class="border-t px-2">
            {{ order.id }}
            <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
            <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
            <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
          </td>
          <td class="border-t px-2">
            {{ order.custom_id }}
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getOrderStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
            {{ order.business.name }}
          </td>
          <td class="border-t px-2">
            {{ order.location.name }}
          </td>
          <td class="border-t px-2">
            {{ order.name }}
          </td>
          <td class="border-t px-2">
            {{ order.phone }}
          </td>
          <td class="border-t px-2">
            {{ order.product_name }}
          </td>
          <td class="border-t px-2">
            {{ order.quantity }}
          </td>
          <td class="border-t px-2">
            {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
            {{ order.product_price }}
          </td>

          <td v-if="order.status.id === 7 || order.status.id === 8" class="border-t px-2">
            {{ order.cancellation_price }}
          </td>
          <td v-else class="border-t px-2">
            {{ order.shipping_price }}
          </td>
          <td class="border-t px-2">
            {{ order.city.name }}
          </td>
          <td class="border-t px-2">
            {{ order.updated_status_at }}
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import SearchFilter from '@/Shared/SearchFilter'
import Icon from '@/Shared/Icon'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileOutput from '@/Shared/FileOutput'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import Dropdown from '@/Shared/Dropdown'
import CurrencyNumberFormat from '@/Shared/CurrencyNumberFormat'
import BarazimStatusTimeline from '@/Shared/BarazimStatusTimeline'
import SearchInput from '@/Shared/SearchInput'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    CurrencyNumberFormat,
    Icon,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    SearchFilter,
    TrashedMessage,
    FileOutput,
    Modal,
    FileInput,
    DangerFlashMessage,
    Dropdown,
    BarazimStatusTimeline,
    SearchInput
  },
  layout: Layout,
  props: {
    barazim: Object,
    statusLogs: Object,
    orders: Object,
    filters: Object
  },
  data() {
    return {
      searchOrderForm: this.$inertia.form({
        search: this.filters.search
      }),
      statusSuccess: this.barazim.data.status_id === 5,
      statusCancellation: this.barazim.data.status_id === 6,
    }
  },
  methods: {
    reset(){
      this.searchOrderForm.search = ''
    },
    getOrderStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      if(statusId === 7)
        statusColor = 'bg-red-500'

      if(statusId === 8)
        statusColor = 'bg-gray-400'

      if(statusId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    }
  },
  watch: {
    searchOrderForm: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/barazimet/${this.barazim.data.id}`,pickBy(this.searchOrderForm),{
          preserveScroll: true,
          preserveState: true,
        })
      }, 150)
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  computed: {
    statusColor(){
      let statusColor = 'bg-indigo-500'
      if(this.barazim.data.status_id === 1)
        statusColor = 'bg-yellow-500'

      if(this.barazim.data.status_id === 2)
        statusColor = 'bg-orange-500'

      if(this.barazim.data.status_id === 3)
        statusColor = 'bg-indigo-900'

      if(this.barazim.data.status_id === 4)
        statusColor = 'bg-green-500'

      if(this.barazim.data.status_id === 5)
        statusColor = 'bg-red-500'

      if(this.barazim.data.status_id === 6)
        statusColor = 'bg-yellow-700'

      return statusColor
    }
  },
}
</script>

<style>
</style>
